export default __webpack_public_path__ + "static/media/loadingV2.879de86d.gif";